'use strict';
var parent = require('../../actual/symbol/iterator');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/full/symbol/iterator.js
// module id = 368
// module chunks = 0